import { UiSchema } from '@rjsf/utils';
import { CustomObjectFieldTemplate, UIGridElement } from '../shared/custom-object-field-template';

const positionGrid: UIGridElement[] = [{ fields: { x: 4, y: 4, a: 4 } }];

const dimensionsGrid: UIGridElement[] = [{ fields: { widthCm: 4, heightCm: 4, depthCm: 4 } }];

const uiGrid: UIGridElement[] = [
  { fields: { name: 6, status: 6 } },
  { title: 'Position', fields: { position: 12 } },
  { title: 'Dimensions', fields: { dimensions: 12 } }
];

export const moduleSettingsFormUISchema: UiSchema = {
  'ui:submitButtonOptions': { norender: true },
  'ui:field': 'custom',
  'ui:grid': uiGrid,
  'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,
  position: {
    'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,
    'ui:grid': positionGrid
  },
  dimensions: {
    'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,
    'ui:grid': dimensionsGrid
  }
};
